export const ENABLE_CPM_AD_MGMT = 'enableCpmAdMgmt';
export const ENABLE_CPM_ENGAGEMENT_PRODUCT = 'enableCpmEngagementProduct';
export const ENABLE_INTERNAL_METRICS = 'enableInternalMetrics';
export const ENABLE_AD_UNIT_UNDER_ENABLE_CPM_EGMT = 'enableAdUnitUnderCpmEngagementProduct';
export const ENABLE_AD_UNIT_UNDER_ENABLE_CPM_AD_MGMT = 'enableAdUnitUnderCpmAdMgmt';